import React, { useDebugValue, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import ToolsPopup from "./ToolsPopup";
import SubRecCandidates from "../../ReviewTools/SubRecCandidates";
import Tools from "../../services/toolsJson.json"
import { getWfPhasesBgColor, getFieldData, getWfPhasesColor } from "../../services/appService";
import {
  loadCandidatesByFilter, getFilterCandidates,
  SendReminder, getReminderStatus,
  loadCandidateApps, getCandidateApps
} from "../../app/store/candidate";
import { getComponentUserStatus, getToolsCount, loadComponentUserStatus, loadToolsCount } from "../../app/store/tools";
import { getApplication, loadApplication, getApplicationData, loadProcessBprmForm, getProccessBprmForm } from "../../app/store/application";
import { getAlert } from "../../services/appAlerts";
import CandidateInfo from "../../app/components/CandidateInfo";
import ApplicationInfo from "../../app/components/ApplicationInfo";
import PartnerInfo from "../../app/components/PartnerInfo";
import ClientAgencyInfo from "../../app/components/ClientAgencyInfo";
import ProjectInfo from "../../app/components/ProjectInfo";
import ToolList from "../../app/components/ToolList";
import TaskInfo from "../../app/components/TaskInfo";
import WorkflowElement from "../../app/components/WorkflowElement";
import JourneySteps from "../../app/components/JourneySteps";
import Document from "../PortalForms/Document";
import TimeLogManagement from "../../ReviewTools/TimeLogManagement";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import {
  getDocuments, getReqDocuments, loadDocuments,
  loadReqDocuments, updateReceivedDocStatus
} from "../../app/store/documents";
import MessageWithApplicant from "../PortalForms/MessageWithApplicant";
import InternalReview from "../PortalForms/InternalReview";
import AchInformation from "../../ReviewTools/AchInformation";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";
import { getCurrentUser } from "../../app/store/auth";
import WorkflowMapPopup from "../WorkflowMapPopup";
import useDocDownload from "../../app/hooks/useDocDownload";
import Moment from "react-moment";
import { getPurchaseOrderDoc, getPurchaseOrders, loadPurchaseOrderDoc, loadPurchaseOrders, purchaseOrderDocReceived } from "../../app/store/purchaseOrder";
import ReceivedDocuments from "../../ReviewTools/ReceivedDocuments";
import config from "../../config.json";
import CandidateReqDoc from "./CandidateReqDoc";
import ReportingDocuments from "../../ReviewTools/ReportingDocuments";

export default function ReviewTask() {

  const newRoute = [
    { name: "Onboarding and Contracts", url: "" },
    { name: "Candidates", url: "/ListCondidate/application" },
    // { name: "Work In Progress", url: "/CustomerApps" }
  ];

  const [selectedTask, setSelectedTask] = useState("");
  const [candidateObj, setCandidateObj] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [appType, setAppType] = useState("");
  const [type, setType] = useState("");
  const [module, setModule] = useState("");
  const [currentTask, setCurrentTask] = useState("");
  const [selectedApp, setSelectedApp] = useState("");
  const [parentApp, setParentApp] = useState("");


  const [componentList, setComponentList] = useState([]);

  const [reAssignShowHide, setReAssignShowHide] = useState(false);
  const [journeyShowHide, setJourneyShowHide] = useState(true);
  const [toolShowHide, setToolShowHide] = useState(false);
  const [sectionShowHide, setSectionShowHide] = useState(false);
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [toolObj, setToolObj] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [apiCallCount, setApiCallCount] = useState(0);
  const [actionType, setActionType] = useState("");
  const [wfForm, setWfForm] = useState(null);
  const [workflowShowHide, setWorkflowShowHide] = useState(null);
  const [tableShowHide, setTableShowHide] = useState(false);
  const [showHideReportingDocs, setShowHideReportingDocs] = useState(false);


  const candidateAppsSelector = useSelector(getCandidateApps);
  const toolsCountSelector = useSelector(getToolsCount);
  const proccessBprmFormSelector = useSelector(getProccessBprmForm);
  const candidatesSelector = useSelector(getFilterCandidates);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const currentUser = getCurrentUser();
  const state = location?.state;

  useEffect(() => {
    console.log("Location State: ", state);
    if (state?.item && state?.app?.ciid)
      dispatch(loadCandidateApps(state?.item.id, "admin", 1, state?.app?.ciid));

    if (state?.appType)
      setAppType(state?.appType);
    if (state?.item)
      setSelectedItem(state?.item);
    if (state?.module)
      setModule(state?.module);
    if (state?.parentApplication)
      setParentApp(state?.parentApplication);
    if (state?.type)
      setType(state?.type);
    if (state?.task)
      setCurrentTask(state?.task);

    if (state?.module === "Subcontractor")
      newRoute[1] = { name: "Subcontractors", url: "/ListSubcontractor/application" };
    if (state?.module === "Recruiter")
      newRoute[1] = { name: "Recruiters", url: "/Recruiter/application" };

    dispatch(setCurrentRoute(newRoute));
    dispatch(setCurrentPageTitle("Review Workflow Task"));
    setActionType("");
  }, []);

  useEffect(() => {
    if (state?.appType !== "partner" && state?.item.id > 0) {
      getCandidateDetails(state?.item.id);
    }

    if (state?.task?.wiid > 0) {
      setSelectedTask(state.task.wiid);
      dispatch(loadToolsCount(state.task.ciid));
      dispatch(loadComponentUserStatus(currentUser.id, state.task.ciid));
      // dispatch(loadDocuments(state.task.ciid));
      // dispatch(loadPurchaseOrders(state?.item.id));
      // dispatch(loadReqDocuments(state.task.ciid));
    }
  }, [])

  useEffect(() => {
    if (candidatesSelector.length > 0)
      setCandidateObj(candidatesSelector[0]);
  }, [candidatesSelector]);

  const getCandidateDetails = async (candidateId) => {
    const frmBody = new FormData();
    frmBody.append("id", candidateId);
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadCandidatesByFilter(frmBody));
  };

  useEffect(() => {
    if (toolsCountSelector.length > 0) {
      setComponentList(Tools.filter(x => x.display === true));
    }
  }, [toolsCountSelector])

  const handleJorneySteps = (wiid) => {
    const wfTask = app.workflowTasks.filter((x) => x.wiid === wiid);
    if (wfTask.length > 0) {
      dispatch(loadProcessBprmForm(wfTask[0].formId));
      setSelectedTask(wfTask[0].wiid);
      setCurrentTask(wfTask[0]);
    }
  };

  useEffect(() => {
    if (candidateAppsSelector.length > 0) {
      const latestApp = candidateAppsSelector[0];
      setSelectedApp(latestApp);

      let wfTasks = latestApp.workflowTasks.filter(
        (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 2 //&& x.formType === "WF"
      ).sort((a, b) => a.orderNumber - b.orderNumber);

      if (wfTasks.length > 1)
        wfTasks = wfTasks.filter(x => x.wfPhase !== "Application");

      if (wfTasks.length === 0) {
        wfTasks = latestApp.workflowTasks.filter(
          (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 4 //&& x.formType === "WF"
        ).sort((a, b) => b.orderNumber - a.orderNumber);
      }

      let latestTask = wfTasks[0];
      let filterContractTask = wfTasks.filter(x => x.itemName === "Contract Management");
      if (filterContractTask.length > 0 && actionType !== "taskDone") {
        latestTask = filterContractTask[0];
      }
      else if (actionType !== "taskDone") {
        filterContractTask = latestApp.workflowTasks.filter((x) => x.itemName === "Contract Management");
        latestTask = filterContractTask.length > 0 ? filterContractTask[0] : latestTask;
      }

      let findCurrentTask = wfTasks.filter(x => x.wiid === currentTask?.wiid);
      if (findCurrentTask.length > 0) {
        findCurrentTask = findCurrentTask[0];
      }

      if ((findCurrentTask?.id !== latestTask?.id) || apiCallCount > 3) {
        console.log("Latest Task: ", latestTask);
        console.log("Current Task: ", currentTask);
        if (!state?.task && currentTask === "") {
          setTimeout(() => {
            dispatch(loadCandidateApps(selectedItem.id, "admin", 1, latestTask.ciid));
          }, 3000);
        }
        setSelectedTask(latestTask.wiid);
        setCurrentTask(latestTask);
        if (latestTask.wfPhase !== "Application") {
          dispatch(loadProcessBprmForm(latestTask.formId));
        }
      }
      else {
        if (apiCallCount > 0 && apiCallCount <= 3) {
          console.log("API Call Count: ", apiCallCount);
          setTimeout(() => {
            setApiCallCount(apiCallCount + 1);
            dispatch(loadCandidateApps(selectedItem.id, "admin", 1, currentTask.ciid));
          }, 3000);

        }
      }
    }

  }, [candidateAppsSelector]);

  useEffect(() => {
    if (proccessBprmFormSelector) setWfForm(proccessBprmFormSelector)
  }, [proccessBprmFormSelector])

  const handleToolShowHide = (r, type) => {
    setUploadType(type);
    setToolShowHide(true);
    const comp = Tools.filter(x => x.id === r);
    if (comp.length > 0)
      setToolObj(comp[0]);
  };

  const handleCompShowHide = (id) => {
    const comp = Tools.filter(x => x.id === id);
    if (comp.length > 0)
      setToolObj(comp[0]);
  }

  const handleToolObjShowHide = (r, p) => {
    const comp = Tools.filter(x => x.id === r);
    if (comp.length > 0) {
      const allTasks = app.workflowTasks.filter(x => x.wfPhase === p);
      if (allTasks.length > 0) {
        setWfForm(null);
        setSelectedTask(0);
      }

      setToolObj(comp[0]);
    }

  }

  const handleNextTask = (btnType) => {
    setTimeout(() => {
      setApiCallCount(1);
      setActionType("taskDone");
      dispatch(loadCandidateApps(selectedItem.id, "admin", 1, currentTask.ciid));
    }, 3000);
  };

  const handleRefreshJourney = () => {
    dispatch(loadCandidateApps(selectedItem.id, "admin", 1, currentTask.ciid));
  }

  const handleReAssignSubmit = () => {
    setReAssignShowHide(false);
    setApiCallCount(3);
    dispatch(loadCandidateApps(selectedItem.id, "admin", 1, currentTask.ciid));
  };

  const handleJourneyShowHide = () => {
    setJourneyShowHide(!journeyShowHide);
  };

  const handleShowHideSection = (status) => {
    setSectionShowHide(status);
  }

  const handleToolHide = () => {
    setToolShowHide(false)
  }

  const handleToolRefresh = () => {
    const state = location?.state;
    if (state.task?.ciid > 0) {
      dispatch(loadToolsCount(state.task.ciid));
      dispatch(loadComponentUserStatus(currentUser.id, state.task.ciid));
    }
  }

  const handleWorkflowModalShowHide = (obj) => {
    setWorkflowShowHide(!workflowShowHide);
  };

  const handleSectionHideShow = (status) => {
    setTableShowHide(status);
  }


  let procType = type;
  let item = "";
  let app = "";
  let wfTask = "";
  let entType = "";

  if (selectedItem !== "") {
    item = selectedItem;
    entType = getFieldData(
      selectedItem?.performerData,
      "candidateonboardingform",
      "CandidateEntity"
    );
  }

  if (selectedApp !== "") app = selectedApp;

  wfTask = currentTask;

  return (
    <React.Fragment>
      <div className="col-md-12">
        <div class="d-flex flex-row-reverse mb-2">
          <button
            className="btn btn-sm btn-outline-default btn-min-width"
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-arrow-left mr-2"></i>Back
          </button>
        </div>
        {item !== "" && (
          <div className="row">
            <div className="col-md-12 form-group mt--4">
              <button className="btn btn-sm btn-link pl-0" onClick={handleToolRefresh}>Refresh</button>
              <div className="card shadow-none mb-0 w-100 mt--2">
                <div className="card-body p-0">
                  <ToolList key={1}
                    compList={componentList.filter((x) => x.group === "Message" || x.group === "Interface" || x.group === "")}
                    handleToolShowHide={handleToolShowHide}
                  />

                  {toolShowHide &&
                    <> <div className="text-left mt-2">
                      <button className="btn btn-sm btn-outline-default" onClick={handleToolHide}>
                        <i className="fa fa-times mr-2" aria-hidden="true"></i>Close
                      </button>
                    </div>
                      <ToolsPopup
                        toolShowHide={toolShowHide}
                        handleToolShowHide={handleToolShowHide}
                        toolObj={toolObj}
                        item={item}
                        task={wfTask}
                        app={app}
                        candidateObj={candidateObj}
                        uploadType={uploadType}
                        setViewBprmFormShowHide={setViewBprmFormShowHide}
                      ></ToolsPopup></>
                  }
                </div>
              </div>
            </div>
            {appType === "partner" && !toolShowHide && (
              <div className="col-md-12">
                <PartnerInfo partner={item} type={type} appType={appType} handleshowtable={handleSectionHideShow} />
              </div>
            )}

            {appType !== "partner" && !toolShowHide && (
              <div className="col-md-12">
                <CandidateInfo candidate={item} handleSectionHideShow={handleSectionHideShow} currentTask={currentTask} app={app} />
              </div>
            )}

            {!tableShowHide && !toolShowHide && (
              <>
                <div className="col-md-12 form-group">
                  {app !== "" && <ApplicationInfo
                    candidate={item}
                    procType={procType}
                    app={app}
                    currentTask={currentTask}
                    appType={appType} />}
                </div>
                <div className="col-md-12 text-center form-group">
                  <button className="btn btn-sm btn-primary w-50">
                    {module} Onboarding
                  </button>
                </div>
              </>
            )}
          </div>
        )}
        {!tableShowHide && (
          <>
            <div className="row">
              <div className="col-md-6">
                {!toolShowHide &&
                  <button
                    className="btn btn-sm btn-link p-0"
                    onClick={() => handleWorkflowModalShowHide(app)}
                  >
                    <span>
                      Workflow ID: {app.workflowId}
                    </span>
                  </button>
                }
              </div>

              {/* <div className="col-md-6">
              {appType !== "partner" && <ProjectInfo candidateObj={item} />}
            </div> */}
              <div className="col-md-12">
                {workflowShowHide && <WorkflowMapPopup
                  workflowShowHide={workflowShowHide}
                  handleWorkflowModalShowHide={handleWorkflowModalShowHide}
                  selectedObj={currentTask}
                ></WorkflowMapPopup>}
              </div>
            </div>
            {!toolShowHide &&
              <div className="row">
                <br />
                <div className="col-md-12">
                  {app !== "" && wfTask && <TaskInfo
                    wfTask={wfTask}
                    app={app}
                    handleReAssignSubmit={handleReAssignSubmit}
                    handleShowHideSection={handleShowHideSection}
                  />
                  }
                </div>
                {!sectionShowHide &&
                  <div className="col-md-12 mb-9" style={{ overflow: "auto" }}>
                    <button
                      className="btn btn-sm btn-link pl-0"
                      onClick={handleJourneyShowHide}
                      aria-label="Workflow Phases"
                    >
                      {journeyShowHide ? "Hide" : "Show"} Workflow Phases
                    </button>
                    <table className="table table-bordered align-items-center">
                      <thead className="">
                        <tr>
                          {journeyShowHide && <th>
                            Workflow Phases
                            {/* Button moved to the end */}
                            <button aria-label="Workflow Phases" className="btn btn-sm btn-link p-0 float-right" onClick={handleRefreshJourney}>
                              {/* <i className="fa fa-refresh" aria-hidden="true"></i> */}
                              Refresh
                            </button>
                          </th>}
                          <th
                            className={`d-flex justify-content-between align-items-center ${wfTask.wfPhase === "Application" ? "btn-wf2-default" : getWfPhasesColor(wfTask.wfPhase)
                              }`}
                          >
                            <span>
                              {wfTask.wfPhase === "Application" ? "Review" : wfTask.wfPhase}

                              {wfTask.wfPhase !== "Application" && (
                                <>
                                  {selectedTask === 0 && toolObj?.name}
                                  : {wfTask?.itemName}

                                </>
                              )}
                            </span>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {app !== "" &&
                          <tr>
                            {journeyShowHide && (
                              <td
                                className="bg-white pl-2 pr-4 pb-5"
                                style={{ minWidth: "30%" }}
                              >
                                <JourneySteps custApp={app}
                                  handleJorneySteps={handleJorneySteps}
                                  handleToolShowHide={handleToolShowHide}
                                  handleToolObjShowHide={handleToolObjShowHide}
                                  candidateObj={candidateObj}
                                  compList={componentList.filter((x) => x.group === "Message" || x.group === "Interface" || x.group === "")}
                                />
                              </td>
                            )}
                            <td
                              className="p-3"
                              style={{ width: "80%", whiteSpace: "pre-wrap" }}
                            >
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-12 form-group">
                                      {selectedTask === 0 && toolObj?.id === 1 && <InternalReview
                                        workflowTask={currentTask}
                                      />}
                                      {wfTask?.itemName === "Contract Management" && (
                                        <>
                                          <button
                                            type="button"
                                            className={`btn btn-sm ${toolObj?.id === 39 ? "btn-default" : "btn-outline-default"} mb-3`}
                                            onClick={() => handleCompShowHide(39)}
                                          >
                                            <i className="fa fa-file-text-o mr-1"></i>Contract Documents
                                          </button>
                                          {entType !== "C2C Basis" &&
                                            <button
                                              type="button"
                                              className={`btn btn-sm ${toolObj?.id === 42 ? "btn-default" : "btn-outline-default"} mb-3`}
                                              onClick={() => handleCompShowHide(42)
                                              }
                                            >
                                              <i className="fa fa-credit-card mr-1"></i>ACH Information
                                            </button>}
                                          {entType !== "C2C Basis" && entType !== "W2 Basis" && entType !== "1099 Basis" &&
                                            <button
                                              type="button"
                                              className={`btn btn-sm ${toolObj?.id === 43 ? "btn-default" : "btn-outline-default"} mb-3`}
                                              onClick={() => handleCompShowHide(43)}
                                            >
                                              <i className="fa fa-shield mr-1"></i>Insurance Information
                                            </button>}

                                          {toolObj?.id === 39 && <ReceivedDocuments
                                            item={item} workflowTask={currentTask} />}


                                          {toolObj?.id === 42 && <AchInformation
                                            workflowTask={currentTask}
                                            app={app}
                                            candidateObj={candidateObj}
                                            item={item}
                                            setViewBprmFormShowHide={setViewBprmFormShowHide}
                                            achType={module}
                                          />}

                                          {toolObj?.id === 43 && <InsuranseInformation
                                            workflowTask={currentTask}
                                            app={app}
                                            candidateObj={candidateObj}
                                            item={item}
                                            setViewBprmFormShowHide={setViewBprmFormShowHide}
                                            insuranceType={module}
                                          />}

                                        </>
                                      )}

                                      {wfTask?.wfPhase === "Approved" && wfTask?.formId === config.formIds.candidate.ReportingForm &&
                                        <>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-default mb-0"
                                            onClick={() => setShowHideReportingDocs(!showHideReportingDocs)}
                                          >
                                            <i className="fa fa-file-text-o mr-1"></i>Documents
                                          </button>
                                          {showHideReportingDocs && <ReportingDocuments workflowTask={currentTask} item={item} />}
                                        </>}

                                      {appType !== "partner" &&
                                        (wfTask?.wfPhase === "Time Log" || wfTask?.wfPhase === "Invoice") &&
                                        !item?.partnerId && (
                                          <>
                                            <TimeLogManagement
                                              workflowTask={currentTask}
                                              app={app}
                                              candidateObj={candidateObj}
                                              item={item}
                                              pType={wfTask?.wfPhase === "Time Log" ? "timelog" : "invoice"}
                                            />
                                          </>
                                        )}

                                      {appType === "partner" &&
                                        (wfTask?.wfPhase === "Time Log" || wfTask?.wfPhase === "Invoice") &&
                                        item?.partnerId > 0 && (
                                          <SubRecCandidates
                                            workflowTask={wfTask}
                                            app={app}
                                            candidateObj={candidateObj}
                                            item={item}
                                            pType={wfTask?.wfPhase === "Time Log" ? "timelog" : "invoice"}
                                            module={module}
                                            appType={appType}
                                            procType={procType}
                                            parentApplication={parentApp}
                                            currentTask={currentTask}
                                          />
                                        )}
                                    </div>
                                  </div>

                                  {wfForm && wfTask.wfPhase !== "Application" &&
                                    <WorkflowElement
                                      wfTask={wfTask}
                                      wfForm={wfForm}
                                      handleNextTask={handleNextTask}
                                      actionType={"workflow"}
                                      viewType={currentUser?.type === "admin" ? false : String(wfTask?.performerId) === String(currentUser?.id) ? false : true}
                                    />
                                  }

                                </div>
                              </div>
                            </td>
                          </tr>}
                      </tbody>
                    </table>
                  </div>}
              </div>}
          </>
        )}
      </div>
    </React.Fragment>
  );
}
